import { Component, OnInit } from '@angular/core';
import { Router, RouterEvent } from '@angular/router';
import { MenuController, ModalController, Platform } from '@ionic/angular';
import { KeycloakService } from 'keycloak-angular';
import { Observable, Subscription } from 'rxjs';
import { App, AppInfo } from '@capacitor/app';
import { KundetilgangModal } from './kundetilgang-modal/kundetilgang-modal.page';
import { BrukerService } from '../services/bruker/bruker.service';
import {
  BrukerkundeResponse,
  KeycloakUserInfo
} from '../services/bruker/bruker.types';
import { DataService } from '../services/datatransfer/DataService';
import { EventsService } from '../services/events/events.service';
import {
  avtaleTab,
  forbrukTab,
  nyttigRoute,
  nyttigTab,
  profilTab,
  regningTab,
  rootTabs,
  spotprisTab,
  enodeRoute,
  enodeTab,
  analyseTab,
  analyseRoute,
  avtaleRoute,
  profilRoute,
  brokerRoute
} from '../routes';
import { FeatureToggle } from '../services/feature-toggles/toggles.types';
import { FeatureTogglesService } from '../services/feature-toggles/feature-toggles.service';
import { SettingsService } from '../services/settings/settings.service';

// eslint-disable-next-line
//declare var $: any; //Jquery deklarasjon til bot script

@Component({
  selector: 'app-tabs',
  templateUrl: 'tabs.page.html',
  styleUrls: ['tabs.page.scss']
})
export class TabsPage implements OnInit {
  loggedIn: boolean;
  kundeIdFromKC: string;

  _brukerkundeResponse: BrukerkundeResponse;
  _showBrukerkunde = false;

  subscription: Subscription;
  subscriptionInit = false;

  zendeskInitialized: boolean;
  zendeskEmail: any;
  zendeskName = '';
  zendeskPhone: any = '';
  isChatbotToggled: boolean;
  toggleResponse: Observable<FeatureToggle[]>;

  modalPage: any;

  selectedPath: string;
  rootTabs = rootTabs;
  profilTab = profilTab;
  regningTab = regningTab;
  forbrukTab = forbrukTab;
  avtaleTab = avtaleTab;
  nyttigTab = nyttigTab;
  spotRoute = spotprisTab;
  nyttigRoute = nyttigRoute;
  enodeRoute = enodeRoute;
  enodeTab = enodeTab;
  analyseTab = analyseTab;
  analyseRoute = analyseRoute;
  avtaleRoute = avtaleRoute;
  profilRoute = profilRoute;
  brokerRoute = brokerRoute;

  isUserEier = false;

  isBrowser = false;
  isIos = false;
  isAndroid = false;
  appVersion: string;

  showContactUs: boolean = false;
  showEnodeInMenu: boolean = false;

  constructor(
    private menu: MenuController,
    private modalCtrl: ModalController,
    public platform: Platform,
    private toggleService: FeatureTogglesService,
    private _brukerService: BrukerService,
    private dataService: DataService,
    private _keycloakService: KeycloakService,
    private router: Router,
    private _eventsService: EventsService,
    private settingsService: SettingsService
  ) {
    this.isBrowser = !platform.is('capacitor');
    this.isAndroid = platform.is('android');
    this.isIos = platform.is('ios');
    if (!this.isBrowser) {
      App.getInfo().then((info: AppInfo) => {
        this.appVersion = info.version;
      });
    }
    // Følg med på url for å kunne sette farge på valgt ikon i menyen
    this.router.events.subscribe((event: any) => {
      if (event instanceof RouterEvent) {
        if (event && event.url) {
          this.selectedPath = event.url;
          if (this.selectedPath.indexOf(rootTabs) > -1) {
            this.selectedPath =
              this.selectedPath.split('/')[2] || this.selectedPath;
          }
        }
        if (this.menu.isOpen()) this.menu.close();
      }
    });

    this._eventsService.getLoggedIn().subscribe((data) => {
      this.loggedIn = data;
    });
    this.toggleResponse = this.toggleService.getActiveFeatureToggles();
  }

  ngOnInit() {
    this.settingsService.showEnodeInMenu$.subscribe((res) => {
      this.showEnodeInMenu = res;
    });
    if (!this.subscriptionInit) this.setupDataChangeListener();

    this._brukerService.getBrukerkunde().subscribe((res) => {
      this._brukerkundeResponse = res;

      if (res.kundenumre && res.kundenumre.length > 1)
        this._showBrukerkunde = true;
    });

    this.toggleResponse.subscribe((res) => {
      this.isChatbotToggled = this.getIsChatbotToggled(res) ?? false;
    });

    this.setUserinfo();
  }

  getIsChatbotToggled(toggles: FeatureToggle[]): boolean {
    const myToggle = toggles.find((x) => x.navn === 'chatbot');
    return myToggle ? myToggle.toggleActive === 'NOW' : false;
  }

  setupDataChangeListener() {
    this.subscription = this.dataService.getKundebytte().subscribe((x) => {
      if (x) {
        // Tabs: vi må reloade pga kundebytte
        this.ngOnInit();
      }
    });

    this.subscriptionInit = true;
  }

  ionViewDidEnter() {
    this.setUserinfo();
  }

  setUserinfo() {
    this.loggedIn = this._keycloakService.isLoggedIn();
    this.isUserEier = this._keycloakService.isUserInRole('eier');
    if (this.loggedIn) {
      this._keycloakService
        .getKeycloakInstance()
        .loadUserInfo()
        .then((userInfo: KeycloakUserInfo) => {
          this.kundeIdFromKC = userInfo.kunde_id;
        });
    }
  }

  showHideMenu() {
    this.menu.toggle();
  }

  getUserFromKundeId(id: string) {
    return (
      (this._brukerkundeResponse?.inUse?.kunde_id === id
        ? this._brukerkundeResponse?.inUse?.navn
        : this._brukerkundeResponse?.kundenumre?.find((x) => x.kunde_id === id)
            ?.navn) || 'Ukjent'
    );
  }

  async openBrukerKunde() {
    this.modalPage = await this.modalCtrl.create({
      component: KundetilgangModal,
      cssClass: 'endre-kundetilganger-modal-content',
      backdropDismiss: true
    });

    if (this.menu.isOpen()) this.menu.toggle();

    await this.modalPage.present();

    this.modalPage.onDidDismiss().then((detail) => {
      if (detail.data?.changedActiveBruker) {
        // Reload component
        this.ngOnInit();
      }
    });
  }

  openContactUs() {
    this.showContactUs = true;
  }
}
